import { c as _c } from "react/compiler-runtime";
import type React from 'react';
const FormGrid = t0 => {
  const $ = _c(6);
  let children;
  let props;
  if ($[0] !== t0) {
    ({
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = props;
  } else {
    children = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== children || $[4] !== props) {
    t1 = <div className="grid gap-4 mb-6 [&>div:not(:last-child)]:pb-6 [&>div:not(:last-child)]:border-b [&>div:not(:last-child)]:border-tertiary" {...props}>{children}</div>;
    $[3] = children;
    $[4] = props;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};
export default FormGrid;